import React, { Component } from 'react';
import { Field, Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import Bluebird from 'bluebird';
import { Paper, Grid, Switch, FormControlLabel, Button, Typography, Box } from '@mui/material';
import snackbarHelper from '../helpers/snackbarHelper';

class SettingsEditForm extends Component {
  handleSubmit = updateSettings => values => Bluebird
    .try(() => updateSettings(values))
    .then(() => snackbarHelper.success('Default sites settings updated successfully!'))
    .catch(err => {
      snackbarHelper.error(err.message);

      return { [FORM_ERROR]: 'error' };
    });

  renderSwitch = ({ input, label }) => (
    <FormControlLabel
      control={
        <Switch
          color="secondary"
          checked={input.checked}
          onChange={event => input.onChange(event.target.checked)}
        />
      }
      label={label}
    />
  );

  render() {
    const { site, settings, onSubmit, title, useTopButtonsLayout, classes } = this.props;
    let initialValues = {};

    settings.map(setting => initialValues[setting.name] = setting.value === '1');

    return (
      <Form
        onSubmit={this.handleSubmit(onSubmit)}
        initialValues={initialValues}
        render={({ handleSubmit, submitting, pristine, invalid, values }) => (
          <form onSubmit={handleSubmit}>
            <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={0}>
              <Grid item xs={12}>
                <Paper sx={{ padding: { xs: 1, sm: 2 }, display: 'flex', flexDirection: 'column' }}>
                  {useTopButtonsLayout && (
                    <Grid spacing={3} container direction="row" justifyContent="space-between" alignItems="center">
                      <Grid item xs>
                        <Typography component="h4">
                          {title}
                        </Typography>
                      </Grid>

                      <Grid item xs>
                        <Box
                          sx={{
                            float: 'right',
                            '& button:first-child': {
                              marginLeft: 1,
                              marginRight: 1,
                            },
                          }}
                        >
                          <Button
                            data-testid="site-feature-flag-submit-button"
                            variant="contained"
                            color="primary"
                            onClick={() => onSubmit(
                              site.id,
                              settings.map(setting => ({ id: setting.id, value: values[setting.name] }))
                            )}
                          >
                            Save
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  )}

                  {!useTopButtonsLayout && (
                    <Typography color="textPrimary" variant="h6">
                      {title}
                    </Typography>
                  )}

                  <Field
                    name="notifications_send_emails"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Send Emails"
                  />

                  <Field
                    name="notifications_send_sms"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Send SMS Messages"
                  />

                  <Field
                    name="notifications_send_push"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Send Push Messages"
                  />

                  <Field
                    name="use_ses_simulator"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Use SES Simulator"
                  />

                  <Field
                    name="use_mailtrap_for_emails"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Use Mailtrap For Emails"
                  />

                  <Field
                    name="use_mailtrap_for_sms"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Use Mailtrap For SMS"
                  />

                  <Field
                    name="use_mailtrap_for_push"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Use Mailtrap For Push"
                  />

                  <Field
                    name="email_whitelist_only"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Email Whitelist Only"
                  />

                  <Field
                    name="sms_whitelist_only"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="SMS Whitelist Only"
                  />

                  <Field
                    name="use_google_maps_geocode"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Use Google Maps For Geocoding"
                  />
  
                  <Field
                    name="use_google_maps_distance_matrix"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Use Google Maps For Calculating Distance & Duration"
                  />

                  <Field
                    name="custom_branding"
                    type="checkbox"
                    component={this.renderSwitch}
                    label="Custom Branding"
                  />

                  {!useTopButtonsLayout && (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={pristine || invalid || submitting}
                      sx={{ marginTop: 1, width: 300 }}
                    >
                      Update Default Sites Settings
                    </Button>
                  )}
                </Paper>
              </Grid>
            </Grid>
          </form>
        )}
      />
    );
  }
}

export default SettingsEditForm;
